export const SECRET = 'SECRET';